import React from 'react'
import Header from './Header'
import TestimonialSection from './TestimonialSection'
import { Link } from 'react-router-dom'
function Testimonials() {
  return (
    <div>
        <Header/>
          <section className="page-header">
    <div className="container">
      <div className="page-header-info">
        <h4>Our Services</h4>
        <h2>
          International services <br /> <span>Ocean and air freight!</span>
        </h2>
        <p>
        Safe and Reliable Transportation understands the importance of all
          facets of the supply chain. That’s why we offer international freight
          services tailored for businesses with global shipping needs. Our
          expertise ensures your products reach their destination on time and in
          excellent condition. International freight shipping plays a crucial
          role in the global supply chain, facilitating trade across borders. At
          Safe and Reliable Transportation, we recognize its significance for
          businesses looking to expand globally.
        </p>
      </div>
    </div>
  </section>
  <TestimonialSection/>
  <footer className="footer-section">
    <div className="map-pattern" />
    <div className="footer-wrapper">
      <div className="container">
        <div className="row gy-lg-0 gy-4">
          <div className="col-lg-3 col-md-6">
            <div className="footer-widget">
              <Link to="/" className="footer-logo">
                <img src="images/logo.png" alt="logo" />
              </Link>
              <p>
              Safe and Reliable Transportation specializes in efficient
                transport warehousing and distribution of goods.
              </p>
              <ul className="social-share">
                <li>
                   <a href="https://www.facebook.com/profile.php?id=61575268596055">
                          <i className="fa-brands fa-facebook-f" />
                        </a>
                </li>
          
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="footer-widget widget-links">
              <div className="widget-title">
                <h3>Company</h3>
              </div>
              <ul className="footer-links">
                <li>
                  <Link to="/aboutus">About Us</Link>
                </li>
                <li>
                  <Link to="/services">Our Services</Link>
                </li>
                <li>
                  <Link to="/testimonials">Testimonials</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="footer-widget">
              <div className="widget-title">
                <h3>Get In Touch</h3>
              </div>
              <ul className="footer-contact-info">
                <li>
                  <p>
                    <span>Address:</span>9528 Baltimore, Ave
Laurel, MD 20723
                  </p>
                </li>
                <li>
                  <p>
                    <span>Mail Us:</span>humanresource@srtranspor.com
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="footer-widget">
              <div className="widget-title">
                <h3>Newslatter Signup</h3>
              </div>
              <form action="#" className="subscribe-form" noValidate="true">
                <div className="mc-fields">
                  <input
                    className="form-control"
                    type="email"
                    name="EMAIL"
                    placeholder="Your Email"
                    required=""
                  />
                  <input
                    type="hidden"
                    name="action"
                    defaultValue="mailchimpsubscribe"
                  />
                  <button className="submit">
                    <i className="fa-regular fa-arrow-right-long" />
                  </button>
                </div>
                <div className="clearfix" />
                <div id="subscribe-result">
                  <div className="subscription-success" />
                  <div className="subscription-error" />
                </div>
              </form>
              <p className="mt-20">
                Subscribe us and get all the benifits from today.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="running-truck">
        <div className="truck" />
        <div className="truck-2" />
        <div className="truck-3" />
      </div>
    </div>
    <div className="copyright-area">
      <span id="currentYear"> </span> © Safe and Reliable Transportation ,
      All Rights Reserved.
    </div>
  </footer>
  {/*/.footer-section*/}
  <div id="scrollup">
    <button id="scroll-top" className="scroll-to-top">
      <i className="fa-regular fa-arrow-up" />
    </button>
  </div>
    </div>
  )
}

export default Testimonials